module.exports = __webpack_public_path__ + "media/icon/favicon-04696295.png";